/**
 * sl-oll9.26: News Portal Gate Constants
 *
 * CSS class constant for the Lit<->React bridge.
 * The body class is toggled by CompositeFeatureGates via createVerticalGateProvider.
 */

/**
 * CSS class name added to body when News Portal is plan-allowed AND configured.
 * Used by isNewsPortalEnabledFromBody() for Lit components.
 */
export const NEWS_PORTAL_ENABLED_CLASS = 'news-portal-enabled';
